export default "* Boplads\n* Hule\n* Bygge\n* Materialer\n* Redskaber\n* Ly/læ\n";